import { Component } from '@angular/core';
import { Router } from '@angular/router';

@Component({
	selector: 'app-side-menu',
	templateUrl: './side-menu.component.html',
	styleUrls: ['./side-menu.component.scss'],
})
export class SideMenuComponent {
	constructor(private router: Router) {}

	signOut() {
		sessionStorage.clear();
		localStorage.clear();
		this.router.navigate([''], {
			replaceUrl: true,
		});
	}
}
